import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`I am currently a recent graduate of Computer Science, focusing on web development applications. My main programming language is JS, but I am also familiar with C# and PHP. I can say programming is not just a hobby for me, as I practice everyday on it.`}</h4>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      